import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import Paginator from "../../../sub/Paginator";
import Util from "../../../../util/Util";
import DateUtil from "../../../../util/DateUtil";
import { Button, Col, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import Icon from "../../../sub/Icon";
import TableToolbar from "../../../sub/bootstrap/TableToolbar";
import Select from "react-select";
import { updateCompany } from "../../../../actions/clients/company/company";
import { updateGroup } from "../../../../actions/clients/groups/groups";

class GroupsListingPharmaciesModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      nameFilter: "",
      urlFilter: "",
      selectedClient: null,
    };
    this.paginator = new Paginator(this);
  }

  resetSearchFields() {
    this.setState({
      nameFilter: "",
      urlFilter: "",
    });
  }

  areResultsFiltered = () => {
    return (
      !Util.emptyString(this.state.nameFilter) ||
      !Util.emptyString(this.state.urlFilter)
    );
  };

  closeModal() {
    this.setState({ modal: null });
  }

  getSelectOptions() {
    const options = [];
    const clients = this.props.company.filter(
      (c) => !this.props.group.companies.includes(c._id) && !c.group_id,
    );
    for (const c of clients) {
      options.push({
        value: c._id,
        label: c.name,
      });
    }
    return options;
  }

  addClient(clientId) {
    let company = this.props.company.find((c) => c._id === clientId);
    company.group_id = this.props.group._id;
    this.props.onCompanyUpdate(company, () => {
      let group = this.props.group;
      group.companies = [...this.props.group.companies, clientId];
      this.props.onGroupUpdate(group, () =>
        this.setState({ selectedClient: null }),
      );
    });
  }

  deleteClient(clientId) {
    let company = this.props.company.find((c) => c._id === clientId);
    company.group_id = null;
    this.props.onCompanyUpdate(company, () => {
      let group = this.props.group;
      group.companies = this.props.group.companies.filter(
        (cId) => cId !== clientId,
      );
      this.props.onGroupUpdate(group, () =>
        this.setState({ selectedClient: null }),
      );
    });
  }

  render() {
    let resetSearchButton = () => {
      let button = (
        <button className="btn btn-outline-secondary ml-3 mr-auto" disabled>
          <Icon icon="filter" />
        </button>
      );
      if (this.areResultsFiltered() && !disableFormInput) {
        return (
          <React.Fragment>
            <OverlayTrigger
              delay={{ hide: 0, show: 0 }}
              overlay={(props) => (
                <Tooltip {...props}>
                  {<FormattedMessage id="Remove.Filter" />}
                </Tooltip>
              )}
              placement="bottom"
            >
              <Button
                variant="warning"
                className="ml-3 mr-auto"
                onClick={() => this.resetSearchFields()}
              >
                <Icon icon="filter" />
              </Button>
            </OverlayTrigger>
          </React.Fragment>
        );
      } else {
        return button;
      }
    };

    const pharmacies = Object.values(this.props.company).filter(
      (items) => items.group_id === this.props.group._id,
    );

    this.paginator.init(pharmacies.length);

    let disableFormInput = this.paginator.paginationIndex !== 1 ? true : false;

    const pharmaciesNode =
      pharmacies.length > 0 &&
      pharmacies.map((pharmacy) => {
        if (this.state.nameFilter && this.state.nameFilter !== "") {
          if (
            pharmacy.name
              .toUpperCase()
              .indexOf(this.state.nameFilter.toUpperCase()) === -1
          )
            return null;
        }

        if (this.state.urlFilter && this.state.urlFilter !== "") {
          if (
            pharmacy.url
              .toLowerCase()
              .indexOf(this.state.urlFilter.toLowerCase()) === -1
          )
            return null;
        }

        if (!this.paginator.keep()) return null;

        return (
          <tr className="d-flex" key={pharmacy._id}>
            <td className="col-4">{pharmacy.name}</td>
            <td className="col-4">{pharmacy.url}</td>
            <td className="col-2">
              {pharmacy.createdAt !== undefined &&
                DateUtil.toDate(pharmacy.createdAt)}
            </td>
            <td className="col-2 text-center">
              <OverlayTrigger
                delay={{ hide: 0, show: 0 }}
                overlay={(props) => (
                  <Tooltip {...props}>
                    {<FormattedMessage id="Delete" />}
                  </Tooltip>
                )}
                placement="top"
              >
                <Button
                  variant={"outline-info"}
                  onClick={() => this.deleteClient(pharmacy._id)}
                >
                  <Icon icon="trash" />
                </Button>
              </OverlayTrigger>
            </td>
          </tr>
        );
      });

    return (
      <Modal
        show={true}
        size="xl"
        onHide={() => this.props.close()}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <FormattedMessage id="Group" /> {this.props.group.name}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <TableToolbar>
            <Col md={10} className="pr-0">
              <Select
                placeholder={<FormattedMessage id="Select.Pharmacy" />}
                options={this.getSelectOptions()}
                isClearable
                noOptionsMessage={() => <FormattedMessage id={"No.Result"} />}
                onChange={(option) => this.setState({ selectedClient: option })}
                value={this.state.selectedClient}
              />
            </Col>
            <Col className="text-right">
              <Button
                variant="info"
                onClick={() => this.addClient(this.state.selectedClient.value)}
                disabled={!this.state.selectedClient}
              >
                <Icon icon="plus-circle" /> <FormattedMessage id="Add" />
              </Button>
            </Col>
          </TableToolbar>

          <div className="mb-5"></div>

          <TableToolbar>
            <input
              id="search_name"
              className="form-control form-control-sm"
              onChange={(e) => this.setState({ nameFilter: e.target.value })}
              placeholder={this.props.intl.formatMessage({
                id: "Name",
              })}
              value={this.state.nameFilter}
              disabled={disableFormInput}
            />
            <input
              id="search_url"
              className="form-control form-control-sm ml-3"
              onChange={(e) => this.setState({ urlFilter: e.target.value })}
              placeholder={this.props.intl.formatMessage({
                id: "URL",
              })}
              value={this.state.urlFilter}
              disabled={disableFormInput}
            />
            {resetSearchButton()}
          </TableToolbar>

          <table className="table tablee4mad">
            <thead>
              <tr className="d-flex">
                <th className="col-4">
                  <FormattedMessage id="Pharmacy" />
                </th>
                <th className="col-4">
                  <FormattedMessage id="URL" />
                </th>
                <th className="col-2">
                  <FormattedMessage id="Creation.Date" />
                </th>
                <th className="col-2 text-center">
                  <FormattedMessage id="Actions" />
                </th>
              </tr>
            </thead>

            <tbody>{pharmaciesNode}</tbody>
          </table>
          {this.paginator.render()}
        </Modal.Body>

        <Modal.Footer>
          <Button
            type="button"
            variant="info"
            onClick={() => this.props.close()}
          >
            <FormattedMessage id="Close" />
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    company: state.company,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onCompanyUpdate: (data, successCallback, failureCallback) =>
      dispatch(updateCompany(data, successCallback, failureCallback)),
    onGroupUpdate: (data, successCallback, failureCallback) =>
      dispatch(updateGroup(data, successCallback, failureCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(GroupsListingPharmaciesModal));
